/** @jsx h */

import TeaserGlobal from './Teaser/TeaserGlobal';

const ResultTeaser = ({ searchType, result, restrictionFilters }) => {
  // Determine correct value for `result.url`
  const rootId = restrictionFilters?.rootId || false;
  const replaceUrl = rootId
    && result?.urls?.length > 0
    && result.urls.filter(
      url => url.root.toString() === restrictionFilters.rootId,
    );

  result.url = replaceUrl[0]?.url || result.url;

  // Select which teaser to render
  switch (searchType) {
    default:
      return <TeaserGlobal result={result} />;
  }
};

export default ResultTeaser;
